(()=>{
  window.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.subpage-top-header').forEach( header => {
      const $bgImg = header.querySelector('.bg img');
      ScrollTrigger.create({
        trigger: header,
        start: 'top top',
        end: 'bottom top',
        onUpdate: (self) => {
          if ($bgImg) {
            const progress = self.progress;
            gsap.set($bgImg, {yPercent: 50 * progress, scale:1 + (0.1 * progress)});
          }
        },
        onEnter: () => {
          header.classList.add('--visible');
        },
        onLeaveBack: () => {
          header.classList.remove('--visible');
        }
      });
    });

    document.querySelectorAll('.section-sub-header').forEach( subHeader => {
      const $bg = subHeader.querySelector('.__bg');
      if ($bg) {
        const $bgImg = $bg.querySelector('img');
        ScrollTrigger.create({
          trigger: $bg,
          start: 'top top',
          end: 'bottom top',
          onUpdate: (self) => {
            const progress = self.progress;
            gsap.set($bgImg, {
              yPercent: progress * 50,
            });
          },
        });
      }


    });

    document.querySelectorAll('[data-anims]').forEach( anims => {
      anims.querySelectorAll('[data-anim]').forEach(anim => {
        const animType = anim.getAttribute('data-anim');
        if (animType === 'char') {
          anim.st = new SplitText(anim.querySelectorAll('.__sentence'), {type: 'chars, words', charsClass: 'char', wordsClass: 'word'});
          gsap.set(anim.st.chars, {opacity:1, yPercent: 120});
        } else if (animType === 'scale-x') {
          gsap.set(anim, {opacity: 0, scaleX: 0, transformOrigin: 'left center' });
        } else {
          gsap.set(anim, {opacity: 0, y: '8rem'});
        }

      });
      ScrollTrigger.create({
        trigger: anims,
        start: 'top 80%',
        end: 'top top',
        once: true,
        onEnter: () => {
          anims.querySelectorAll('[data-anim]').forEach((item, index) => {
            const animType = item.getAttribute('data-anim');
            if (animType === 'char') {
              gsap.set(item, {opacity:1});
              gsap.to(item.st.chars, {
                opacity: 1,
                yPercent: 0,
                duration: 1,
                ease: Circ.easeOut,
                stagger: 0.025,
                delay: 0.2 * index,
                onComplete: () => {
                  item.classList.add('--animated');
                }
              });
            } else if (animType === 'scale-x') {
              gsap.set(item, {opacity:1});
              gsap.to(item, {scaleX:1,  duration: 1.4,
                ease: Circ.easeInOut,
                delay: 0.2 * index,
                onComplete: () => {
                  gsap.set(item, { clearProps: 'all' });
                  item.classList.add('--animated');
                }})
            } else {
              gsap.to(item, {
                opacity: 1,
                y: 0,
                duration: 1.4,
                ease: Circ.easeOut,
                delay: 0.2 * index,
                onComplete: () => {
                  gsap.set(item, { clearProps: 'all' });
                  item.classList.add('--animated');
                }
              });
            }

          });
        }
      });
    });


    document.querySelectorAll('.scrolled-gallery').forEach((gallery) => {
      const scrollArea = gallery.querySelector('.scroll-area');
      const imgs = gallery.querySelector('.imgs');
      ScrollTrigger.create({
        trigger: gallery,
        start: 'bottom bottom',
        end: 'top 4%',
        onUpdate: (self) => {
          const progress = self.progress;
          const scrollWidth = scrollArea.clientWidth - imgs.clientWidth;
          const tx = (scrollWidth * progress);
          gallery.style.setProperty('--translate-x', `${tx}px`);
        },
      });
    });


    document.querySelectorAll('[data-parallax-img]').forEach((item) => {
      const img = item.querySelector('img');
      gsap.set(img, {objectPosition: '50% 100%'});
      ScrollTrigger.create({
        trigger: img,
        start: 'top bottom',
        end: 'bottom top',
        onUpdate: (self) => {
          const progress = self.progress;
          gsap.set(img, {objectPosition: `50% ${100 - (progress * 100)}%`});
        },
      });
    });
  });

})();